//
//
//
//
//
//

import Duration from '../items/ProductInfoItemDuration.vue';

export default {
  name: 'product-card-info-video',
  components: {
    Duration,
  },
  props: {
    element: Object,
  },
};
